Specific contact people for the position opening at the party.
